import { NgModule } from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import {QuickApplyContainerComponent} from "./quick-apply-container/quick-apply-container.component";
import {QuickApplySubmitComponent} from "./quick-apply-submit/quick-apply-submit.component";
import {QuickApplyStartComponent} from "./quick-apply-start/quick-apply-start.component";
import {QuickApplyOtpComponent} from "./quick-apply-otp/quick-apply-otp.component";
import {QuickApplyPasswordComponent} from "./quick-apply-password/quick-apply-password.component";
import {TalentHappyPathAuthResolver} from "../shared/service/talent-happy-path-auth.resolver";
import { QuickApplyWelcomeComponent } from './quick-apply-welcome/quick-apply-welcome.component';
import { QuickApplyInviteComponent } from "./quick-apply-invite/quick-apply-invite.component";


const routes: Routes = [
  {
    path: '',
    component: QuickApplyContainerComponent,
    resolve: { talent: TalentHappyPathAuthResolver },
    children: [
      { path: 'invite', component: QuickApplyInviteComponent },
      { path: 'login', component: QuickApplyStartComponent },
      { path: 'start', component: QuickApplyStartComponent },
      { path: 'otp', component: QuickApplyOtpComponent },
      { path: 'welcome', component: QuickApplyWelcomeComponent },
      { path: 'password', component: QuickApplyPasswordComponent },
      { path: 'submit', component: QuickApplySubmitComponent },
      { path: 'new', component: QuickApplySubmitComponent },
      { path: 'update', component: QuickApplySubmitComponent }
    ]
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuickApplyRoutingModule {}
